/* PP · Schaufenster – Startseiten-Leisten: Blätter-Pfeile mittig zum Kartenbild (Bildhöhe der ersten Karte als --pp-bildhoehe am Leisten-Rahmen,
   Aussehen in pp-global.css); beobachtet die Bildgröße (Drehen, Fenster ziehen).
   Wo benutzt: sections/pp-schaufenster.liquid (templates/index.json, 3×)      Abschaltbar: mit dem Abschnitt (ohne Skript: Pfeile auf Standardhöhe)
   Horizon-Stellen: .pp-fenster .resource-list__carousel > slideshow-container, .card-gallery (Horizons Karussell in der Kopie von product-list)
   Fehlt eine Stelle: tut nichts. Braucht: pp-basis.js
   Katalog: shop/baukasten/bausteine.md · Stand: 2026-10-07 (C4 Schritt 3: aus assets/pp-global.js, pfeilHoehe) */
(function () {
  var PP = window.PP;
  if (!PP || !PP.erstesMal || !PP.erstesMal('schaufenster')) return; // ohne pp-basis.js nichts tun; nur einmal einrichten (Abschnitt steht 3× auf der Startseite)

  // 02.10.2026 (Nutzer: Pfeil der Produktleisten „komisch ausgerichtet“): Pfeile der Startseiten-Leisten mittig zum Kartenbild –
  // Bildhöhe der ersten Karte als --pp-bildhoehe am Leisten-Rahmen (pp-global.css); beobachtet die Bildgröße (Drehen, Fenster ziehen)
  var phBeob = null;
  function pfeilHoehe() {
    var b = document.querySelectorAll('.pp-fenster .resource-list__carousel > slideshow-container');
    for (var i = 0; i < b.length; i++) {
      var g = b[i].querySelector('.card-gallery'); if (!g) continue;
      if (g.offsetHeight) b[i].style.setProperty('--pp-bildhoehe', g.offsetHeight + 'px');
      if (window.ResizeObserver && !g.__ppBeob) { if (!phBeob) phBeob = new ResizeObserver(pfeilHoehe); phBeob.observe(g); g.__ppBeob = true; }
    }
  }

  window.addEventListener('resize', pfeilHoehe);
  PP.beimStart(190, pfeilHoehe);
})();
